const profAnim = document.querySelectorAll('[id*="animation"]');
window.addEventListener('scroll', function(){
    profAnim.forEach((element, index) => {
    if(iSinViewport(element, 400)){
        element.play();
    }else{
        element.pause();
    }
    })
});

const iSinViewport = (elem, offset = 0) => {
    let windowHeight = window.innerHeight;
    let viewportOffset = elem.getBoundingClientRect(); 
    let top = viewportOffset.top + offset; 
    let btm = viewportOffset.bottom - offset; 
    
    if(top < windowHeight){ 
        return true;
    } else{
        return false;
    }
}